import { useTranslate } from '@refinedev/core';
import { Tooltip, theme } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { formatLedgerDelta, isZeroAmount } from '@/utils/money';

interface RoundingDeltaHintProps {
  /** `payable_amount − amount`, at the ledger's four places. May be negative. */
  delta: string;
  currency: string;
}

/**
 * What the invoice's rounding did to this row, when it did anything. Renders
 * nothing at zero, so a visible arrow always means the row was rounded.
 *
 * The arrow carries the sign, which is what someone reconciling a report is
 * looking for. Tertiary colour rather than danger — a grosz of rounding is
 * lawful, not an error.
 */
export const RoundingDeltaHint = ({
  delta,
  currency,
}: RoundingDeltaHintProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  if (isZeroAmount(delta)) return null;

  const Arrow = Number(delta) > 0 ? ArrowUpOutlined : ArrowDownOutlined;

  return (
    <Tooltip
      title={t('settlement.hints.rounding_delta', {
        delta: formatLedgerDelta(delta, currency),
      })}
    >
      <Arrow
        style={{ color: token.colorTextTertiary, fontSize: token.fontSizeSM }}
      />
    </Tooltip>
  );
};
